module.exports = __webpack_public_path__ + "media/images/konintodoke/top_recommend/fish-left-icon-c3b89589888475e0901b2919d683612e.svg";